export default "__VITE_ASSET__D05jgtc8__"